import { useCallback, useRef, useState } from 'react';

export type MoyasarPaymentLifecycleState =
  | 'form_ready'
  | 'initiating'
  | 'provider_created'
  | 'completed_or_failed';

export function isMoyasarSubmissionLocked(state: MoyasarPaymentLifecycleState): boolean {
  return state === 'initiating' || state === 'provider_created';
}

export function useMoyasarPaymentLifecycle() {
  const [state, setState] = useState<MoyasarPaymentLifecycleState>('form_ready');
  const stateRef = useRef<MoyasarPaymentLifecycleState>('form_ready');
  const onLifecycleChange = useCallback((next: MoyasarPaymentLifecycleState) => {
    stateRef.current = next;
    setState(next);
  }, []);
  const reset = useCallback(() => onLifecycleChange('form_ready'), [onLifecycleChange]);
  const isLockedNow = useCallback(
    () => isMoyasarSubmissionLocked(stateRef.current),
    [],
  );
  return {
    state,
    submissionLocked: isMoyasarSubmissionLocked(state),
    isLockedNow,
    onLifecycleChange,
    reset,
  };
}
